import {IApplicationState} from '../../../../../../types/types';
import { IAppTab } from '../../../../../../store/model/tabs/types';

export const getTab = (
    state: IApplicationState,
    boardId: number
): IAppTab => {
    return state.model.tabs[boardId];
};
